import { Filters as AntdFilters } from "@empglabs/backoffice-ui-kit"
import { forwardRef } from "react"

const Filters = forwardRef((props, ref) => {
  return <AntdFilters ref={ref} {...props} />
})


export default Filters
